import type { CreateDirectDebitMandateCommand } from '../../models/directDebit/createDirectDebitMandateCommand';
import type { CreatePaymentIntentFromBasketCommand } from '../../models/directDebit/createPaymentIntentFromBasketCommand';
import { requests } from '../httpClient';

export const DirectDebitMandate = {
    submitDirectDebitDetailsAsync: (createDirectDebitMandateCommand: CreateDirectDebitMandateCommand) =>
        requests.post(`DirectDebitMandate/FromBasket`, createDirectDebitMandateCommand),
    getDirectDebitMandateByIdAsync: (id: string) => requests.get(`DirectDebitMandate/${id}`),
    getDirectDebitMandatesAsync: () => requests.get(`DirectDebitMandate`),
    deleteDirectDebitMandateByIdAsync: (id: string) => requests.delete(`DirectDebitMandate/${id}`),
    payByDDMandateFromBasketAsync: (createPaymentIntentFromBasketCommand: CreatePaymentIntentFromBasketCommand) =>
        requests.post(`DirectDebitMandate/PayByDDMandateFromBasket`, createPaymentIntentFromBasketCommand)
};
